import { type UsernameData } from '../types';

const DEFAULT_FORM_DATA: UsernameData = {
  shoudRemember: false,
  username: '',
};

/** Loads username data including whether we should remember it or not */
export function loadUsernameData(): UsernameData {
  const raw = localStorage.getItem('auth/login-form/remember');

  if (!raw) {
    return DEFAULT_FORM_DATA;
  }

  try {
    const json = atob(raw);
    const saved = JSON.parse(json) as UsernameData;

    return {
      shoudRemember: !!saved.shoudRemember,
      username: saved.username || '',
    };
  } catch {
    return DEFAULT_FORM_DATA;
  }
}

/** Saves username data including whether we should remember it or not */
export function saveUsernameData(data: UsernameData): void {
  // Save default values if `shouldRemember` is not true.
  const toSave = {
    ...(data.shoudRemember ? data : DEFAULT_FORM_DATA),
    shoudRemember: data.shoudRemember,
  };
  const json = JSON.stringify(toSave);
  const encoded = btoa(json);

  localStorage.setItem('auth/login-form/remember', encoded);
}
